/* @flow */
import Collection from 'lib/Collection';
import Device from 'entities/Device';

class Devices extends Collection<Device> {
  initialize() {
    // $FlowIssue
    this.url = '/devices';
    this.model = Device;
  }

  type(type: SubscriptionMedium): Device[] {
    return this.models.filter(model => model.getType() === type);
  }

  enabled(): Device[] {
    return this.models.filter(model => model.isEnabled());
  }
}

export default Devices;
